import { getRole } from 'constants/localStorageManager';
import { USERS } from 'constants/Users';

export const metricsStyleSelector = (comparison, value) => {
  const type = getComparisonType(value);

  const increasing = {
    percentage: {
      icon: 'arrow-circle-up',
      fontClass: 'text-success',
    },
    number: {
      icon: 'plus',
      fontClass: 'dash-blue-color',
    },
  };

  const decreasing = {
    percentage: {
      icon: 'arrow-circle-down',
      fontClass: 'text-danger',
    },
    number: {
      icon: 'minus',
      fontClass: 'text-danger',
    },
  };

  const noChange = {
    icon: 'minus-circle',
    fontClass: 'text-secondary',
  };

  if (comparison == 'increasing') {
    return increasing[type];
  }
  if (comparison == 'constant') {
    return noChange;
  }
  if (comparison == 'decreasing') {
    return decreasing[type];
  }
  return {};
};

export const getComparisonType = (value) => {
  const changeValue = value.toString();
  const isPercentage = changeValue.includes('%');
  const type = isPercentage ? 'percentage' : 'number';
  return type;
};

export const getChangeType = (value) => {
  const changeValue = parseFloat(value);
  if (changeValue) return changeValue > 0 ? 'increasing' : 'decreasing';
  return 'constant';
};

export const createLayoutConfig = (components = [], w = 3, h = 4, immovable = false) => {
  let newLayout = {
    i: '0',
    x: 0,
    y: 0,
    w,
    h,
    static: immovable,
  };

  if (components.length) {
    const layouts = components.map(comp => comp.layout_config);
    const layout = layouts.reduce((max, lay) => (max.i > lay.i ? max : lay));

    const { layout_config } = { layout_config: layout } || { layout_config: newLayout };

    const {
      i, x, y, w: add_w
    } = layout_config;

    const new_i = (parseInt(i) + 1).toString();
    if (x + 2 * add_w >= 12) {
      const newY = y + h;
      newLayout = {
        i: new_i,
        x: 0,
        y: newY,
        w,
        h,
        static: immovable,
      };
    } else {
      const newX = x + add_w;
      newLayout = {
        i: new_i,
        x: newX,
        y,
        w,
        h,
        static: immovable,
      };
    }
  }

  return newLayout;
};

export const isMetricsDisabled = (components, name) => {
  const metricComponent = components
    .filter(component => component.dashboard_config.metric === name);

  if (metricComponent.length < 1) {
    return [];
  }

  return metricComponent.map((comp) => {
    return comp.dashboard_config.type ? comp.dashboard_config.type : 'number';
  }).filter(x => x);
};

export const onlyShowMetrics = ({ supportedComponents, restrictToUsers }) => {
  const role = getRole();
  const showMetrics = [...supportedComponents];

  if (role !== USERS.ADMIN) {
    restrictToUsers.forEach((comp) => {
      const index = showMetrics.indexOf(comp);

      showMetrics.splice(index, 1);
    });
  }

  return showMetrics;
};

export const calculateAvailableMetrics = (metrics) => {
  let count = 0;
  metrics.forEach((metric) => {
    const supportedComponents = onlyShowMetrics(metric);

    if (supportedComponents.length > 0) { count += supportedComponents.length; }
  });
  return count;
};



// WEBPACK FOOTER //
// ./src/utils/metricesHelper.js